<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    :max-width="maxWidth"
    persistent>
    <v-card>
      <v-card-title v-if="title" class="headline">{{title}}</v-card-title>

      <v-card-text>
        <slot></slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="action"></slot>
        <v-btn
          v-show="showCancelBtn"
          @click="$emit('cancel')"
          flat>
          {{cancelBtnText}}
        </v-btn>

        <v-btn
          v-show="showConfirmBtn"
          @click="$emit('confirm')"
          :class="themeColor"
          :loading="loading"
          color="black"
          flat>
          {{confirmBtnText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    // custom v-model value
    value: {},
    title: {
      type: String
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    },
    confirmBtnText: {
      type: String,
      default: '確認'
    },
    maxWidth: {
      default: '300'
    },
    loading: {
      default: false
    },
    showConfirmBtn: {
      default: true
    },
    showCancelBtn: {
      default: true
    }
  }
};
</script>
